import{STORE_FORM_INPUT}from"../constants";/**
 * Creates the dispatched STORE_FORM_INPUT action object.
 * @param {Object} input The user form input.
 * @returns {Object}
 */var storeFormInput=function storeFormInput(input){return{type:STORE_FORM_INPUT,input:input};};export default storeFormInput;